<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" x-small text @click.stop="importAction"
        ><v-icon small>mdi-database-import</v-icon></v-btn
      >
    </template>
    <span> Import Action </span>
    <confirm-modal ref="confirm"></confirm-modal>
  </v-tooltip>
</template>

<script>
import ConfirmModal from "../../Shared/confirm-modal";

export default {
  props: ["assignment"],
  components: {
    ConfirmModal,
  },
  methods: {
    importAction: async function () {
      if (
        await this.$refs.confirm.open(
          "Import this action from BOE?",
          "Note: This action cannot be undone.",
          "Import"
        )
      ) {
        this.$store.commit("uxModule/setShowLoader", true);
        let message = await this.$store.dispatch("plansModule/importAction", {
          legacyActionId: this.assignment.legacyActionId,
        });
        this.$store.commit("uxModule/setShowLoader", false);

        if (message) {
          this.$store.commit("uxModule/setSnackbarMsg", message);
          this.$store.commit("uxModule/setShowSnackbar", true);
        }
      }
    },
  },
};
</script>
